module.exports = __webpack_public_path__ + "img/clip-message-sent-1.a34f244b.png";